import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import FileUpload from "./FileUpload";
import Header from "../../../components/header";
import ParentWrapper from "../../../components/ParentWrapper";

function Audio() {
  return (
    // <Box>
    //   <Box>
    //     <Box
    //       sx={{
    //         ml: {
    //           xs: "0px",
    //           md: "230px",
    //         },
    //         p: 3

    //       }}
    //     >

         <ParentWrapper>
          <Box
            sx={{
              display: {
                xs: "none",
                md: "initial",
              },
            }}
          >
            <Header title={"Upload Audio"} subHeading={"Upload audio for instant conversation review"} />

          </Box>
          <Grid container sx={{ mb: 2 }}>
            <Grid item xs={12} md="">
              <Typography
                sx={{
                  fontSize: "1.8rem",
                  fontWeight: 900,
                  color: "#424242",
                }}
                gutterBottom
              >
                {/* Upload Audio */}
              </Typography>
              <FileUpload />
            </Grid>
          </Grid>
          </ParentWrapper>
      //  {/* </Box> */}
    //   </Box>
    // </Box>
  );
}

export default Audio;
